import axios from "axios";
import { logDetailed } from "../../helpers/utils";
import ProofsheetContext from "../../imageBrowserContext/ProofsheetContext";

export const openProofsheetFromExamList = ({ dispatch, getters, state }) => {
  logDetailed("actions", "openProofsheetFromExamList", "execution-time", "beforeLoad");
  let beforeLoad = Date.now();
  window.beforeLoadProofsheet = beforeLoad;
  return dispatch("loadImageMetadataForAllExams").finally(() => {
    let exams = getters.selectedExams;
    if (!exams || !exams.length) exams = getters.exams;
    let images = state.imageMap.filter(i => exams.some(e => e.exSrNo === i.exSrNo));
    let elapsed = Date.now() - beforeLoad;
    logDetailed("actions", "openProofsheetFromExamList", "execution-time", "whole procedure", elapsed);
    dispatch("openProofsheet", images);
  });
};

export const openProofsheet = ({ commit, dispatch }, images) => {
  if (!images.length) {
    commit("displayStatus", { message: "Please select at least 1 image.", level: "error" });
    return;
  }
  let context = new ProofsheetContext(images);
  commit("setProofsheetContext", context);
  commit("addToBrowserStack", context);
  dispatch("loadProofsheetImages");
};

export const closeProofsheet = ({ commit, dispatch, getters }) => {
  commit("clearProofsheetContext");
  commit("clearImageQueue", "imageQueue");
  dispatch("popBrowserStack");
  dispatch("selectPatient", getters.patient);
};

export const selectEyeProofsheet = ({ commit, dispatch }, eye) => {
  commit("selectEyeProofsheet", eye);
  dispatch("loadProofsheetImages");
};

export const selectFilterProofsheet = ({ commit, dispatch }, option) => {
  commit("selectFilterProofsheet", option);
  dispatch("loadProofsheetImages");
};

export const selectImageProofsheet = ({ commit, dispatch, getters }, image) => {
  commit("selectImageProofsheet", image);
  if (!getters.proofsheetShowAll)
    dispatch("loadProofsheetImages");
};

export const selectAllProofsheet = ({ commit, dispatch, getters }) => {
  commit("selectAllProofsheet");
  if (!getters.proofsheetShowAll)
    dispatch("loadProofsheetImages");
};

export const startDeleteImages = ({ commit, getters }) => {
  if (!getters.selectedProofsheetImages.length)
    commit("displayStatus", { message: "Please select at least 1 image.", level: "error" });
  else commit("startDeleteImages");
};

export const deleteImages = ({ commit, getters }) => {
  let imgSrNos = getters.proofsheetImagesToDelete.map(i => i.flSrNo);
  return axios.post("api/image/deleteImages", imgSrNos)
    .then(response => {
      if (!response.data || !response.data.success) return Promise.reject();
      commit("removeImagesProofsheet", imgSrNos);
      commit("removeImagesMultiview", imgSrNos);
      commit("removeImagesImageMap", imgSrNos);
      commit("cancelDeleteImages");
      commit("displayStatus", { message: "Success!", level: "success" });
    }).catch(() => {
      commit("displayStatus", { message: "An error occurred while removing images. Please try again later.", level: "error" });
    });
};

export const startDownloadImages = ({ commit, dispatch, getters }) => {
  if (!getters.selectedProofsheetImages.length)
    commit("displayStatus", { message: "Please select at least 1 image.", level: "error" });
  else {
    return dispatch("generateImageDownloadZip");
  }
};

export const generateImageDownloadZip = ({ commit, getters }) => {
  let imgSrNos = getters.selectedProofsheetImages.map(i => i.flSrNo);
  commit("setLoadingMessage", "Generating zip file");
  return axios.post("/api/image/generateZip", imgSrNos)
    .then(response => {
      if (!response.data || !response.data.success) return Promise.reject();
      commit("setActiveDownload", { link: response.data.fileName, text: "Are you sure you want to download the selected image(s)?" });
    })
    .catch(error => {
      commit("displayStatus", { message: "An error occurred while generating the zip file, please try again later.", level: "error" });
      return Promise.reject(error);
    })
    .finally(() => commit("setLoadingMessage", null));
};

export const downloadActiveFile = ({ commit, dispatch, getters }) => {
  if (!getters.activeDownloadLink) return;
  let fileName = getters.activeDownloadLink;
  let escaped = encodeURIComponent(fileName);
  commit("setLoadingMessage", "Downloading zip file");
  return axios.get("api/exam/zip/?fileName=" + escaped, {
    responseType: "arraybuffer"
  }).then(response => {
    let blob = new Blob([response.data], { type: "application/octet-stream" });
    return dispatch("downloadBlob", { blob, fileName });
  }).catch(() => {
    commit("displayStatus", { message: "An error occurred while downloading the zip file, please try again later.", level: "error" });
  }).finally(() => {
    commit("setLoadingMessage", null);
  });
};

export const startMarkImages = ({ commit, getters }) => {
  if (!getters.selectedProofsheetImages.length)
    commit("displayStatus", { message: "Please select at least 1 image.", level: "error" });
  else commit("startMarkImages");
};

export const markImages = ({ commit, getters }, eye) => {
  let imgSrNos = getters.selectedProofsheetImages.map(i => i.flSrNo);
  let exSrNo = getters.selectedProofsheetImages.map(i => i.exSrNo);
  exSrNo = exSrNo.filter((item, i, ar) => ar.indexOf(item) === i);
  let request = { imgSrNos, eye,exSrNo };
  return axios.post("api/image/markImages", request)
    .then(response => {
      if (!response.data || !response.data.success) return Promise.reject();
      commit("updateImageLaterality", request);
      commit("clearSelectedImages");
      commit("displayStatus", { message: "Success!", level: "success" });
      commit("cancelMarkImages");      
    }).catch(() => {
      commit("displayStatus", { message: "An error occurred while marking images. Please try again later.", level: "error" });
    });
};

export const updateCurrentImagesProofsheet = ({ dispatch, commit }, bounds) => {
  commit("setCurrentImagesProofsheet", bounds);
  return dispatch("loadProofsheetImages");
}

export const loadProofsheetImages = ({ dispatch, getters }) =>
  dispatch("loadImages_proof", getters.currentProofsheetImages);